import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  Spinner,
  Image,
  Loading,
  Button,
  DataTable,
  ButtonGroup,
  Toast,
  Checkbox,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  Select,
} from "@shopify/polaris";
import axios from "../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../Assets/Images/emptyList.svg";
import { useNavigate } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
import makeAnimated from "react-select/animated";
import Pagination from "@mui/material/Pagination";
import EllipsisText from "react-ellipsis-text";
import moment from "moment";
import { capitalizeFirstLetter } from "../Helpers";
import { CategoriesIcon } from "@shopify/polaris-icons";

const SubscribersComponent = ({ type }) => {
  const navigate = useNavigate();
  const addEditState = useRef("");
  const perPage = 50;
  const [ts, setTs] = useState("");
  const [availability, setAvailability] = useState("");
  const [queryValue, setQueryValue] = useState("");
  const [page, setPage] = useState(1);
  const [pageObject, setPageObject] = useState({
    isLoading: true,
    isSaving: false,
    tableItems: [],
    tableTotalPages: 0,
    isListEmpty: false,
  });
  const handleAddRecentSession = () => {
    navigate("/admin/settings/recentSessions-and-permissions/new");
  };
  function handleFiltersQueryChange(queryValue) {
    refBoolPage.current = false;
    setQueryValue(queryValue);
  }
  function handleAvailabilityChange(availability) {
    setAvailability(availability);
  }
  const handleAvailabilityRemove = useCallback(() => setAvailability(""), []);
  const handleQueryValueRemove = useCallback(() => setQueryValue(""), []);
  const handleFiltersClearAll = useCallback(() => {
    handleAvailabilityRemove();
    handleQueryValueRemove();
  }, [handleAvailabilityRemove, handleQueryValueRemove]);

  const filters = [
    {
      key: "availability",
      label: "Filter by",
      filter: (
        <ChoiceList
          title="Filter by"
          titleHidden
          choices={[
            { label: "First Name", value: "user.first_name" },
            { label: "Last Name", value: "user.last_name" },
            { label: "Email", value: "user.email" },
            { label: "Phone Number", value: "user.phone_number" },
          ]}
          selected={availability || []}
          onChange={handleAvailabilityChange}
        />
      ),
      shortcut: false,
    },
  ];

  const appliedFilters = [];
  if (!isEmpty(availability)) {
    const key = "availability";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, availability),
      onRemove: handleAvailabilityRemove,
    });
  }
  const loadingMarkup = pageObject.isLoading ? <Loading /> : null;
  const emtyState = pageObject.isListEmpty ? (
    <div
      style={{
        display: "flex",
        justifyContent: "middle",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <Image src={emptyListImage}></Image>
      </div>
      <div className="mb-3">
        <Text variant="bodyLg" as="p">
          No results found
        </Text>
      </div>
      <br />
    </div>
  ) : (
    pageObject.isLoading && (
      <div className="spinnerContainer">
        <div className="vertical-center">
          <Spinner size="large" />
        </div>
      </div>
    )
  );
  const refBoolPage = useRef(true);
  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };

  const handleClickRow = (param) => {
    //  navigate(`/admin/recent-sessions/${param}`, "_blank");
    window.open(`/admin/subscriptions/${param}`, "_blank");
  };
  const [isSaving, setIsSaving] = useState(false);
  const [selectedClass, setSelectedClass] = useState("");
  const [optionsClasses, setOptionsClasses] = useState([
    { label: "All", value: "all" },
  ]);
  const [optionsElements, setOptionsElements] = useState([
    { label: "All", value: "all" },
  ]);
  const [selectedElement, setSelectedElement] = useState("");
  const handleSelectChangeClass = (newValue) => {
    setSelectedClass(newValue);
  };
  const handleSelectChangeElement = (newValue) => {
    setSelectedElement(newValue);
  };
  const [selectedDate, setSelectedDate] = useState("");
  const handleChangeDate = (newValue) => {
    setSelectedDate(newValue);
  };
  const [selectedDateTo, setSelectedDateTo] = useState("");
  const handleChangeDateTo = (newValue) => {
    setSelectedDateTo(newValue);
  };
  const [selectedIsPrivate, setSelectedIsPrivate] = useState("");
  const handleChangeIsPrivate = (newValue) => {
    setSelectedIsPrivate(newValue);
  };
  const handleBookings = (param) => {
    navigate(`/admin/sessions/${param}/bookings`);
  };
  useEffect(() => {
    fetchData();
  }, [ts, availability, queryValue, page, selectedDate]);
  const switchStatusColor = (param) => {
    switch (param) {
      case "pending":
        return `default`;
      case "confirmed":
        return `success`;
      case "cancelled":
        return `warning`;
      case "cancelled with charge":
        return `warning`;
      case "failed":
        return `critical`;
      default:
        return "";
    }
  };
  const parseName = (jsonObj) => {
    if (jsonObj?.submembership?.name) {
      return jsonObj.submembership.name;
    } else if (jsonObj?.subpackage?.name) {
      return jsonObj.subpackage.name;
    }
    return null;
  };
  async function fetchData() {
    let responseSubscriptions = "";
    try {
      responseSubscriptions = await axios.get(
        `/subscriptions?per_page=${perPage}&page=${
          refBoolPage.current ? page : 1
        }&filter[is_valid]=${type === "active" ? 1 : 0}${
          queryValue
            ? `&filter[${
                availability === "" ? "user.email" : availability
              }]=${queryValue}`
            : ""
        }`
      );
      console.log("test", responseSubscriptions.data.data.data);
      setPageObject({
        ...pageObject,
        tableItems: responseSubscriptions?.data?.data?.data?.map(
          (item, index) => [
            <div
              className="clickableDiv"
              onClick={() => handleClickRow(item.id)}
            >
              {item.user?.id}
            </div>,
            <div
              className="clickableDiv"
              onClick={() => handleClickRow(item.id)}
            >
              {item?.user && item?.user?.first_name
                ? item?.user?.first_name
                : "-"}
            </div>,
            <div
              className="clickableDiv"
              onClick={() => handleClickRow(item.id)}
            >
              {item?.user && item?.user?.last_name
                ? item?.user?.last_name
                : "-"}
            </div>,
            <div
              className="clickableDiv"
              onClick={() => handleClickRow(item.id)}
            >
              {item.user && item?.user?.birthday ? item.user.birthday : "-"}
            </div>,
            <div
              className="clickableDiv"
              onClick={() => handleClickRow(item.id)}
            >
              {item?.user && item?.user?.email ? item?.user?.email : "-"}
            </div>,
            <div
              className="clickableDiv"
              onClick={() => handleClickRow(item.id)}
            >
              {item?.user && item?.user?.nationality
                ? item?.user?.nationality
                : "-"}
            </div>,
            <div
              className="clickableDiv"
              onClick={() => handleClickRow(item.id)}
            >
              {item?.user && item?.user?.phone_number
                ? item?.user?.phone_number
                : "-"}
            </div>,
            <div
              className="clickableDiv"
              onClick={() => handleClickRow(item.id)}
            >
              {item?.type ? item?.type : "-"}
            </div>,
            <div
              className="clickableDiv"
              onClick={() => handleClickRow(item.id)}
            >
              {parseName(item)}
            </div>,
            <div
              className="clickableDiv"
              onClick={() => handleClickRow(item.id)}
            >
              {item?.amount !== null ? item?.amount : "-"}
            </div>,
            <div
              className="clickableDiv"
              onClick={() => handleClickRow(item.id)}
            >
              {item?.start_date
                ? moment(item?.start_date).format("YYYY-MM-DD HH:mm:ss")
                : "-"}
            </div>,
            <div
              className="clickableDiv"
              onClick={() => handleClickRow(item.id)}
            >
              {item?.expiry_date
                ? moment(item?.expiry_date).format("YYYY-MM-DD HH:mm:ss")
                : "-"}
            </div>,
            <div
              className="clickableDiv"
              onClick={() => handleClickRow(item.id)}
            >
              {item?.status ? (
                <Badge tone={switchStatusColor(item.status)}>
                  {capitalizeFirstLetter(item?.status)}
                </Badge>
              ) : (
                "-"
              )}
            </div>,
            <div
              className="clickableDiv"
              onClick={() => handleClickRow(item.id)}
            >
              {item?.created_at
                ? moment(item?.created_at).format("YYYY-MM-DD HH:mm:ss")
                : "-"}
            </div>,
          ]
        ),
        isLoading: false,
        isListEmpty: !responseSubscriptions.data.data.data.length
          ? true
          : false,
        tableTotalPages: responseSubscriptions.data.data.total,
      });
    } catch (error) {
      console.log(error);
    }
  }

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "This recentSession has been successfully verified"
  );

  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const refId = useRef(null);
  const [activeVerify, setActiveVerify] = useState(false);
  const handleChangeModalVerify = useCallback((activeVerify) => {
    setActiveVerify(!activeVerify);
    setIsSaving(false);
  }, []);
  const handleYesVerify = () => {
    setIsSaving(true);
    axios
      .post(`/recent-sessions/${refId.current}/verify`)
      .then((result) => {
        toggleActive();
        setIsSaving(false);
        setActiveVerify(!activeVerify);
        setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };
  return (
    <div>
      <FormLayout>
        <Filters
          queryValue={queryValue}
          queryPlaceholder="Search..."
          filters={filters}
          appliedFilters={appliedFilters}
          onQueryChange={handleFiltersQueryChange}
          onQueryClear={handleQueryValueRemove}
          onClearAll={handleFiltersClearAll}
        />
      </FormLayout>

      <DataTable
        columnContentTypes={["text", "text", "text", "text"]}
        headings={[
          <Text variant="bodyMd" as="p" fontWeight="medium">
            User ID
          </Text>,
          <Text variant="bodyMd" as="p" fontWeight="medium">
            First Name
          </Text>,
          <Text variant="bodyMd" as="p" fontWeight="medium">
            Last Name
          </Text>,
          <Text variant="bodyMd" as="p" fontWeight="medium">
            Date of Birth
          </Text>,
          <Text variant="bodyMd" as="p" fontWeight="medium">
            Email
          </Text>,
          <Text variant="bodyMd" as="p" fontWeight="medium">
            Nationality
          </Text>,
          <Text variant="bodyMd" as="p" fontWeight="medium">
            Phone Number
          </Text>,
          <Text variant="bodyMd" as="p" fontWeight="medium">
            Type
          </Text>,
          <Text variant="bodyMd" as="p" fontWeight="medium">
            Subpackage/Submembership
          </Text>,
          <Text variant="bodyMd" as="p" fontWeight="medium">
            Amount
          </Text>,
          <Text variant="bodyMd" as="p" fontWeight="medium">
            Start Date
          </Text>,
          <Text variant="bodyMd" as="p" fontWeight="medium">
            Expiry Date
          </Text>,
          <Text variant="bodyMd" as="p" fontWeight="medium">
            Status
          </Text>,
          <Text variant="bodyMd" as="p" fontWeight="medium">
            Created at
          </Text>,
        ]}
        rows={pageObject.tableItems}
        verticalAlign="middle"
        increasedTableDensity
        footerContent={
          pageObject.tableItems?.length &&
          `Showing ${pageObject.tableItems.length} of ${pageObject.tableTotalPages} results`
        }
        hasZebraStripingOnData
      />
      {emtyState}
      {Math.ceil(pageObject.tableTotalPages / perPage) >= 2 && (
        <div
          style={{
            paddingTop: "10px",
            textAlign: "center",
            paddingBottom: "10px",
          }}
        >
          <Pagination
            variant="outlined"
            count={Math.ceil(pageObject.tableTotalPages / perPage)}
            page={page}
            onChange={handleChangePage}
          />
          {/* <Pagination
              count={Math.ceil(pageObject.tableTotalPages / perPage)}
              page={page}
              onChange={handleChangePage}
              size="large"
            /> */}
        </div>
      )}
    </div>
  );
  function disambiguateLabel(key, value) {
    switch (key) {
      case "taggedWith":
        return `Tagged with ${value}`;
      case "availability":
        return `Filter by ${value}`;
      default:
        return value;
    }
  }
  function isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else {
      return value === "" || value == null;
    }
  }
};

export default SubscribersComponent;
